import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterModel: { items: [] }, // Initial empty filter state
  filters: {},
  selectedFilterFields: {},
  processedRows: [],
  hasNewFilters: false,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterModel: (state, action) => {
      state.filterModel = action.payload;
    },

    setFilters: (state, action) => {
      const { module, filters } = action.payload;

      // Get existing filters for the module
      const existingFilters = state.filters[module] || {};

      // Check if new filters are different from existing ones
      const isDifferent =
        JSON.stringify(existingFilters) !== JSON.stringify(filters);

      state.filters = {
        ...state.filters,
        [module]: filters,
      };

      // If filters are changed, update the flag
      if (isDifferent) {
        state.hasNewFilters = true;
      }
    },

    setSelectedFilterFields: (state, action) => {
      const {
        module,
        searchKey,
        searchValue,
        label,
        isQueryParam,
        labelValue,
        valueKey,
      } = action.payload;

      const currentFilters = state.selectedFilterFields[module] || [];

      const existingIndex = currentFilters.findIndex(
        (filter) => filter.searchKey === searchKey
      );

      let updatedFilters;
      if (existingIndex >= 0) {
        updatedFilters = currentFilters.map((filter, index) =>
          index === existingIndex
            ? {
                searchKey,
                searchValue,
                label,
                isQueryParam,
                labelValue,
                valueKey,
              }
            : filter
        );
      } else {
        updatedFilters = [
          ...currentFilters,
          { searchKey, searchValue, label, isQueryParam, labelValue, valueKey },
        ];
      }

      state.selectedFilterFields = {
        ...state.selectedFilterFields,
        [module]: updatedFilters,
      };
    },

    setHasNewFilters: (state) => {
      state.hasNewFilters = false;
    },

    removeFilter: (state, action) => {
      const { module, searchKey } = action.payload;

      if (state.selectedFilterFields[module]) {
        // Create a new array instead of mutating state
        state.selectedFilterFields = {
          ...state.selectedFilterFields,
          [module]: state.selectedFilterFields[module].filter(
            (filter) => filter.searchKey !== searchKey
          ),
        };
      }
    },

    clearFilters: (state, action) => {
      const { module } = action.payload;

      // Return a new object instead of mutating existing state
      state.filters = {
        ...state.filters,
        [module]: [],
      };

      state.selectedFilterFields = {
        ...state.selectedFilterFields,
        [module]: [],
      };

      state.hasNewFilters = false;
    },

    setProcessedRows: (state, action) => {
      state.processedRows = action.payload;
    },

    clearAllFilters: (state, action) => {
      const { module } = action.payload;

      state.filterModel = { items: [] };
      // Return a new object instead of mutating existing state
      state.filters = {
        ...state.filters,
        [module]: [],
      };

      state.selectedFilterFields = {
        ...state.selectedFilterFields,
        [module]: [],
      };

      state.hasNewFilters = false;
    },
  },
});

export const {
  setFilterModel,
  setProcessedRows,
  removeFilter,
  clearFilters,
  clearAllFilters,
  setFilters,
  setSelectedFilterFields,
  setHasNewFilters,
} = filterSlice.actions;
export default filterSlice.reducer;
